<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .cta-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: utils.in_rem(4px);

    .cta-label {
      @include colors.color(black_90);
      @include mixins.body4();
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>

<script>
  // Svelte
  import { getContext } from "svelte";
  // Components
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  // Context
  import { CONTACT_CTAS_CONTEXT } from "./context";

  // Get store from context
  const { activePopUpModalStore, candidateStore, itemStore } =
    getContext(CONTACT_CTAS_CONTEXT);

  const openModal = () => {
    activePopUpModalStore.set({
      modal: "addManualToDo",
      actionedFrom: $itemStore?.kind === "manualToDo" ? "manualToDoPage" : null,
      selectedCandidateId: $candidateStore.candidateId,
      onclose: () => activePopUpModalStore.set(null),
    });
  };
</script>

<div class="cta-wrapper">
  <ButtonWithTooltip
    kind="secondary"
    class=""
    leadingIcon=""
    trailingIcon=""
    size="candidate-cta"
    placement="top"
    onclick={openModal}
  >
    <span slot="tooltip">Create manual task</span>
    <IconScale class="fa-fw fa-check" size="medium" />
  </ButtonWithTooltip>
  <span class="cta-label">Task</span>
</div>
